export default "__VITE_ASSET__SsagZLsk__"